import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../components/AuthContext';
import { doctor_login } from './../api';

import {useAppContext } from './../AppContext';

function DoctorLoginPage() {
   const { user, setUser } = useAppContext();
  const navigate = useNavigate();
  const { setIsAuthenticated } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setError('');
    
    if (!email.trim() || !password.trim()) {
      setError('Please enter both email and password.');
      return;
    }

    setLoading(false);

    doctor_login(email.trim(),password.trim()).then((response)=>{
      if(response.statusCode === 404) {
setIsAuthenticated(false);
      console.log(error);
       setError('Authentication failed');
      } else {
        console.log(response);
        setUser(response);
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
          setIsAuthenticated(true);
          navigate('/doctor-dashboard'); // adjust route as needed
        }, 800);
      }
    }).catch((error)=>{
      setIsAuthenticated(false);
      console.log(error);
       setError('Authentication failed');
    }).finally(()=>{

    });

   
  };

  return (
    <div className="page-card centered-card">
      <div className="padding-lg">
        <h2 className="page-heading">Login</h2>
        <p className="page-copy text-muted">
          Enter your credentials to access your physician workspace.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group spaced">
            <label className="form-label">Email</label>
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              className="form-control"
              placeholder="doctor@example.com"
              required
            />
          </div>

          <div className="form-group spaced">
            <label className="form-label">Password</label>
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="form-control"
              placeholder="Enter your password"
              required
            />
          </div>

          {error && <div className="alert alert-danger">{error}</div>}

          <button type="submit" className="btn btn-primary w-100" disabled={loading} style={{ backgroundColor: '#0b5ed7' }}>
            {loading ? <span className="spinner"></span> : 'Sign in'}
          </button>

         
        </form>
      </div>
    </div>
  );
}

export default DoctorLoginPage;
